export type AiKey = "pacoca" | "bochecha";

const CACHE_PREFIX = "ai_limit_reached_";

function getTodayEndTimestamp(): number {
    const now = new Date();
    const end = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59, 999);
    return end.getTime();
}

/** Marca no cache local que a IA atingiu o limite diário de tokens (expira à meia-noite). */
export function setAiLimitReached(ai: AiKey, idUser: number | undefined) {
    try {
        localStorage.setItem(CACHE_PREFIX + ai + `_${idUser}`, String(getTodayEndTimestamp()));
    } catch { }
}

/** Verifica no cache local se a IA está com o limite diário atingido. */
export function isAiLimitReached(ai: AiKey, idUser: number | undefined): boolean {
    try {
        const raw = localStorage.getItem(CACHE_PREFIX + ai + `_${idUser}`);
        if (!raw) return false;

        if (Date.now() > Number(raw)) {
            localStorage.removeItem(CACHE_PREFIX + ai + `_${idUser}`);
            return false;
        }

        return true;
    } catch {
        return false;
    }
}

/** Identifica se um texto retornado pela IA é a mensagem de limite diário atingido. */
export function detectAiLimitMessage(text?: string | null): boolean {
    return typeof text === "string" && text.includes("limite diário de tokens");
}

/** Identifica qual IA foi mencionada em um texto (post/comentário/mensagem). */
export function detectMentionedAi(text?: string | null): AiKey | null {
    if (!text) return null;
    if (/@BochechaAI\b/i.test(text)) return "bochecha";
    if (/@pacoca_ai\b/i.test(text)) return "pacoca";
    return null;
}

export function aiDisplayName(ai: AiKey): string {
    return ai === "bochecha" ? "Bochecha AI" : "Paçoca AI";
}
